import { render } from "./pageHead.vue?vue&type=template&id=ba13cad2&scoped=true"
import script from "./pageHead.vue?vue&type=script&lang=js"
export * from "./pageHead.vue?vue&type=script&lang=js"

import "./pageHead.vue?vue&type=style&index=0&id=ba13cad2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba13cad2"]])

export default __exports__